import { render } from "./PageNotFound404.vue?vue&type=template&id=ba3202f2"
import script from "./PageNotFound404.vue?vue&type=script&lang=js"
export * from "./PageNotFound404.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__